export default class ThemeManager {
    constructor() {
        this.themes = {
            'soft-earth': {
                name: 'Soft Earth',
                primary: '#9e8b74',
                secondary: '#a6aa8d',
                accent: '#b69f87',
                price: 0
            },
            'neon-core': {
                name: 'Neon Core',
                primary: '#00f3ff', // Cyan
                secondary: '#ff0055', // Pink
                accent: '#ccff00', // Lime
                price: 0
            },
            'cyber-green': {
                name: 'Cyber Green',
                primary: '#ccff00', // Lime
                secondary: '#bf00ff', // Purple
                accent: '#00f3ff', // Cyan
                price: 300
            },
            'solar-flare': {
                name: 'Solar Flare',
                primary: '#ffaa00', // Orange
                secondary: '#ffff00', // Yellow
                accent: '#ff0055', // Red
                price: 300
            },
            'midnight': {
                name: 'Midnight',
                primary: '#0066ff', // Deep Blue
                secondary: '#ffffff', // White
                accent: '#ff00ff', // Magenta
                price: 200
            },
            'crimson-tide': {
                name: 'Crimson Tide',
                primary: '#ff0000', // Red
                secondary: '#ffd700', // Gold
                accent: '#800000', // Maroon
                price: 300
            },
            'ocean-breeze': {
                name: 'Ocean Breeze',
                primary: '#00ced1', // Dark Turquoise
                secondary: '#e0ffff', // Light Cyan
                accent: '#4682b4', // Steel Blue
                price: 300
            },
            'candy-pop': {
                name: 'Candy Pop',
                primary: '#ff69b4', // Hot Pink
                secondary: '#00bfff', // Deep Sky Blue
                accent: '#ffff00', // Yellow
                price: 400
            },
            'toxic-waste': {
                name: 'Toxic Waste',
                primary: '#39ff14', // Neon Green
                secondary: '#8a2be2', // Blue Violet
                accent: '#ffff00', // Yellow
                price: 400
            },
            'sunset-blvd': {
                name: 'Sunset Blvd',
                primary: '#ff4500', // Orange Red
                secondary: '#ff1493', // Deep Pink
                accent: '#ffd700', // Gold
                price: 400
            },
            'deep-space': {
                name: 'Deep Space',
                primary: '#9370db', // Medium Purple
                secondary: '#00bfff', // Deep Sky Blue
                accent: '#ffffff', // White
                price: 500
            },
            'forest-fire': {
                name: 'Forest Fire',
                primary: '#228b22', // Forest Green
                secondary: '#ff4500', // Orange Red
                accent: '#ffd700', // Gold
                price: 500
            },
            'royal-guard': {
                name: 'Royal Guard',
                primary: '#ffd700', // Gold
                secondary: '#800080', // Purple
                accent: '#dc143c', // Crimson
                price: 600
            },
            'ice-cold': {
                name: 'Ice Cold',
                primary: '#00ffff', // Aqua
                secondary: '#f0f8ff', // Alice Blue
                accent: '#00008b', // Dark Blue
                price: 300
            },
            'lava-flow': {
                name: 'Lava Flow',
                primary: '#ff4500', // Orange Red
                secondary: '#ff8c00', // Dark Orange
                accent: '#8b0000', // Dark Red
                price: 500
            },
            'bubblegum': {
                name: 'Bubblegum',
                primary: '#ffc0cb', // Pink
                secondary: '#add8e6', // Light Blue
                accent: '#ffffff', // White
                price: 300
            },
            'mint-choc': {
                name: 'Mint Choc',
                primary: '#98ff98', // Mint Green
                secondary: '#8b4513', // Saddle Brown
                accent: '#f5fffa', // Mint Cream
                price: 300
            },
            'bumblebee': {
                name: 'Bumblebee',
                primary: '#ffd700', // Gold
                secondary: '#333333', // Dark Grey
                accent: '#ffffff', // White
                price: 400
            },
            'vaporwave': {
                name: 'Vaporwave',
                primary: '#ff71ce', // Pink
                secondary: '#01cdfe', // Cyan
                accent: '#05ffa1', // Green
                price: 500
            },
            'matrix': {
                name: 'The Matrix',
                primary: '#00ff00', // Lime
                secondary: '#003300', // Dark Green
                accent: '#ffffff', // White
                price: 1200
            },
            'rainbow': {
                name: 'Rainbow',
                primary: '#ff0000', // Red
                secondary: '#0000ff', // Blue
                accent: '#ffff00', // Yellow
                price: 2500
            },
            'dracula': {
                name: 'Dracula',
                primary: '#ff0000', // Red
                secondary: '#333333', // Dark Grey
                accent: '#ffffff', // White
                price: 600
            },
            'pumpkin': {
                name: 'Pumpkin',
                primary: '#ffa500', // Orange
                secondary: '#008000', // Green
                accent: '#333333', // Dark Grey
                price: 300
            },
            'aquamarine': {
                name: 'Aquamarine',
                primary: '#7fffd4', // Aquamarine
                secondary: '#00ced1', // Dark Turquoise
                accent: '#20b2aa', // Light Sea Green
                price: 400
            },
            'berry-blast': {
                name: 'Berry Blast',
                primary: '#8a2be2', // Blue Violet
                secondary: '#ff1493', // Deep Pink
                accent: '#dc143c', // Crimson
                price: 400
            },
            'neon-gold': {
                name: 'Neon Gold',
                primary: '#ffd700',
                secondary: '#ff4500',
                accent: '#ffffff',
                price: 500
            },
            'neon-ice': {
                name: 'Neon Ice',
                primary: '#00ffff',
                secondary: '#ffffff',
                accent: '#0088ff',
                price: 300
            },
            'neon-cyber': {
                name: 'Neon Cyber',
                primary: '#bd00ff',
                secondary: '#00ff9d',
                accent: '#ff0055',
                price: 800
            },
            'neon-nature': {
                name: 'Neon Nature',
                primary: '#39ff14',
                secondary: '#008000',
                accent: '#ffff00',
                price: 300
            },
            'neon-sunset': {
                name: 'Neon Sunset',
                primary: '#ff5e00',
                secondary: '#8a2be2',
                accent: '#ffd700',
                price: 400
            }
        };

        this.effects = {
            'effect-soft': { name: 'Soft', class: 'effect-soft', price: 0 },
            'effect-neon': { name: 'Neon', class: 'effect-neon', price: 0 },
            'effect-metal': { name: 'Metal', class: 'effect-metal', price: 200 },
            'effect-fire': { name: 'Fire', class: 'effect-fire', price: 1000 },
            'effect-water': { name: 'Water', class: 'effect-water', price: 400 },

            // Batch 1
            'effect-cyberpunk': { name: 'Cyberpunk', class: 'effect-cyberpunk', price: 1500 },
            'effect-galaxy': { name: 'Galaxy', class: 'effect-galaxy', price: 2000 },
            'effect-matrix': { name: 'Matrix', class: 'effect-matrix', price: 1200 },
            'effect-ice': { name: 'Ice', class: 'effect-ice', price: 500 },
            'effect-electric': { name: 'Electric', class: 'effect-electric', price: 800 },
            'effect-rainbow': { name: 'Rainbow', class: 'effect-rainbow', price: 2500 },
            'effect-hologram': { name: 'Hologram', class: 'effect-hologram', price: 1200 },
            'effect-gold': { name: 'Gold', class: 'effect-gold', price: 5000 },
            'effect-toxic': { name: 'Toxic', class: 'effect-toxic', price: 600 },
            'effect-arcade': { name: 'Arcade', class: 'effect-arcade', price: 1000 },

            // Batch 2
            'effect-crystal': { name: 'Crystal', class: 'effect-crystal', price: 2200 },
            'effect-circuit': { name: 'Circuit', class: 'effect-circuit', price: 1400 },
            'effect-hazard': { name: 'Hazard', class: 'effect-hazard', price: 600 },
            'effect-phantom': { name: 'Phantom', class: 'effect-phantom', price: 1800 },
            'effect-soap': { name: 'Soap', class: 'effect-soap', price: 400 },
            'effect-sketch': { name: 'Sketch', class: 'effect-sketch', price: 900 },
            'effect-grid': { name: 'Grid', class: 'effect-grid', price: 700 },
            'effect-magma': { name: 'Magma', class: 'effect-magma', price: 1600 },
            'effect-scanner': { name: 'Scanner', class: 'effect-scanner', price: 1100 },
            'effect-static': { name: 'Static', class: 'effect-static', price: 300 }
        };

        this.currentTheme = 'soft-earth';
        this.currentEffect = 'effect-soft';
        this.loadTheme();
    }

    async loadFromServer(baseUrl) {
        try {
            const res = await fetch(`${baseUrl}/economy/shop-items`);
            if (res.ok) {
                const items = await res.json();
                items.forEach(item => {
                    if (item.type === 'THEME') {
                        this.themes[item.id] = {
                            name: item.name,
                            primary: item.primary_color,
                            secondary: item.secondary_color,
                            accent: item.accent_color,
                            price: item.price
                        };
                    } else if (item.type === 'EFFECT') {
                        this.effects[item.id] = {
                            name: item.name,
                            class: item.css_class || item.id,
                            price: item.price
                        };
                    }
                });

                // Reapply in case new configs came in for current setup
                this.applyTheme(this.currentTheme);
                this.applyEffect(this.currentEffect);
            }
        } catch (e) {
            console.error("Failed to load shop items from server:", e);
        }
    }

    applyTheme(themeKey) {
        if (!this.themes[themeKey]) return;

        this.currentTheme = themeKey;
        const theme = this.themes[themeKey];
        const root = document.documentElement;

        root.style.setProperty('--primary-color', theme.primary);
        root.style.setProperty('--secondary-color', theme.secondary);
        root.style.setProperty('--accent-color', theme.accent);

        this.saveTheme();
    }

    applyEffect(effectKey) {
        if (!this.effects[effectKey]) return;

        this.currentEffect = effectKey;
        const root = document.documentElement;

        // Remove old effect classes
        Object.values(this.effects).forEach(effect => {
            root.classList.remove(effect.class);
        });

        // Add new effect class
        root.classList.add(this.effects[effectKey].class);

        this.saveTheme();
    }

    getTheme() {
        return this.themes[this.currentTheme];
    }

    saveTheme() {
        localStorage.setItem('pixelblob_theme', this.currentTheme);
        localStorage.setItem('pixelblob_effect', this.currentEffect);
        localStorage.setItem('quickygame_theme', this.currentTheme);
        localStorage.setItem('quickygame_effect', this.currentEffect);
    }

    loadTheme() {
        const saved = localStorage.getItem('pixelblob_theme') || localStorage.getItem('quickygame_theme');
        const blockedThemes = new Set(['neon-core', 'candy-pop', 'bubblegum', 'vaporwave', 'rainbow', 'midnight', 'neon-ice', 'neon-cyber']);
        if (saved && this.themes[saved] && !blockedThemes.has(saved)) {
            this.applyTheme(saved);
        } else {
            this.applyTheme('soft-earth');
        }

        const savedEffect = localStorage.getItem('pixelblob_effect') || localStorage.getItem('quickygame_effect');
        const blockedEffects = new Set(['effect-neon', 'effect-cyberpunk', 'effect-electric', 'effect-rainbow', 'effect-hologram', 'effect-arcade']);
        if (savedEffect && this.effects[savedEffect] && !blockedEffects.has(savedEffect)) {
            this.applyEffect(savedEffect);
        } else {
            this.applyEffect('effect-soft');
        }
    }
}
